import React from 'react';
import './HighlightedText.css';

interface HighlightedTextProps {
  text: string;
  searchTerm: string;
  className?: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({ text, searchTerm, className = '' }) => {
  if (!searchTerm.trim()) {
    return <span className={className}>{text}</span>;
  }

  // Escape special regex characters in search term
  const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  // Create regex to find all instances (case insensitive)
  const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');

  // Split text by search term while preserving the search term
  const parts = text.split(regex);

  return (
    <span className={className}>
      {parts.map((part, index) => {
        // Check if this part matches the search term (case insensitive)
        const isMatch = regex.test(part);
        regex.lastIndex = 0; // Reset regex for next test

        return isMatch ? (
          <mark key={index} className="search-highlight">
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        );
      })}
    </span>
  );
};

export default HighlightedText;
